/**
 * WP Swiper Plugin - Elementor Integration
 * Version: 1.0.0
 */

(function($) {
    'use strict';
    
    var WPSwiperElementor = {
        
        init: function() {
            $(window).on('elementor/frontend/init', this.onElementorFrontendInit.bind(this));
            
            if (typeof elementorFrontend === 'undefined') {
                $(document).ready(this.initSwipers.bind(this));
            }
        },
        
        onElementorFrontendInit: function() {
            elementorFrontend.hooks.addAction('frontend/element_ready/masked_overlay_slider.default', this.initWidget.bind(this));
        },
        
        initWidget: function($scope) {
            var $swiperContainer = $scope.find('.wp-swiper-elementor');
            if ($swiperContainer.length) {
                this.createSwiper($swiperContainer);
            }
        },
        
        initSwipers: function() {
            $('.wp-swiper-elementor').each(function() {
                WPSwiperElementor.createSwiper($(this));
            });
        },
        
        createSwiper: function($container) {
            var $swiperElement = $container.find('.swiper');
            
            if ($swiperElement.length === 0) {
                return;
            }
            
            var config = $container.data('swiper-config') || {};
            var slideCount = $swiperElement.find('.swiper-slide').not('.swiper-slide-duplicate').length;
            
            // 检测是否为移动端
            var isMobile = window.innerWidth < 768;
            
            // 🔥 移动端和桌面端使用不同的 stretch 值
            var defaultConfig = {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: slideCount || 5,
                speed: 500,
                coverflowEffect: {
                    rotate: 0,
                    stretch: isMobile ? '15%' : '50%', // 🔥 移动端 15%，桌面端 50%
                    depth: 0,
                    modifier: 1,
                    slideShadows: false
                }
            };
            
            if (config.pagination) {
                defaultConfig.pagination = config.pagination;
            }
            
            if (config.navigation) {
                defaultConfig.navigation = config.navigation;
            }
            
            if (config.hasOwnProperty('autoplay') && config.autoplay) {
                defaultConfig.autoplay = config.autoplay;
            }
            
            var finalConfig = defaultConfig;
            
            try {
                var swiper = new Swiper($swiperElement[0], finalConfig);
                
                // Store swiper instance
                $container.data('swiper-instance', swiper);
                
                // Handle responsive updates
                $(window).on('resize', function() {
                    if (swiper && swiper.update) {
                        var newIsMobile = window.innerWidth < 768;
                        if (newIsMobile !== isMobile) {
                            // 屏幕尺寸跨越断点，重新初始化
                            WPSwiperElementor.destroySwiper($container);
                            WPSwiperElementor.createSwiper($container);
                        } else {
                            swiper.update();
                        }
                    }
                });
                
            } catch (error) {
                console.error('WP Swiper Plugin: Error initializing swiper', error);
            }
        },
        
        destroySwiper: function($container) {
            var swiper = $container.data('swiper-instance');
            if (swiper && swiper.destroy) {
                swiper.destroy(true, true);
                $container.removeData('swiper-instance');
            }
        }
    };
    
    WPSwiperElementor.init();
    
    window.WPSwiperElementor = WPSwiperElementor;
    
})(jQuery);
